import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { PreLoginKcRealmVO } from '@repo/types'

export interface PreLoginFormValues {
  mail: string
  realm: PreLoginKcRealmVO
}

const keycloakRealmSchema = z
  .object({
    realm: z.string(),
    loginUrl: z.string()
  })
  .required()

const loginFormSchema = z
  .object({
    mail: z
      .string()
      .min(1, { message: 'E-mail é obrigatório' })
      .email({ message: 'Por favor, insira um e-mail válido' }),
    realm: keycloakRealmSchema
  })
  .required()

export const usePreLoginForm = () => {
  const resolver = zodResolver(loginFormSchema)

  const form = useForm<PreLoginFormValues>({
    mode: 'onSubmit',
    resolver,
    defaultValues: {
      mail: ''
    }
  })

  return { ...form }
}
